import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import Canonical from "../components/Canonical";

const Thankyou = () => {
  const canonicalUrl = `https://homesdekho.com/thankyou`;
  const metaTitle = "Thank You for Contacting HomesDekho";
  const hrfLangTag = "https://homesdekho.com/thankyou";

  return (
    <>
      <Canonical
        canonicalUrl={canonicalUrl}
        title={metaTitle}
        hrfLang={hrfLangTag}
      />
      <div className="container mt-5 mb-5 text-center">
        <div className="row">
          <div className="col-md-12">
            <h1>THANK YOU!</h1>
            <FaCheckCircle className="thankyou-icon" />
            <p class="mt-3" data-lead-id="main-content-body">
              Thanks a bunch for filling that out. It means a lot to us, just
              like you do! We really appreciate you giving us a moment of your
              time today. Thanks for being you.
            </p>
            <Link to="/" className="get-call-btn-property-home-page me-3">
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Thankyou;
